module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/5/5-b5fcbe0336337f977c81ead002b480af.jpg";